var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-top",class:{ 'show': _vm.show },on:{"click":function($event){return _vm.goTop()}}},[_c('i',{staticClass:"fas fa-chevron-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }